import { call, select, put, all, takeLatest } from "redux-saga/effects";
import {
  selectFormReqLeave,
  selectIdRequestLeaveDetail,
  timeListConfigSelector,
} from "../redux/selector";
import { checkIsExitsReqLeaveApi } from "core/http/service/timeKeeping";
import {
  checkIsExitsReqLeaveFailed,
  checkIsExitsReqLeaveStart,
  checkIsExitsReqLeaveSuccess,
} from "../redux/checkIsExitsReqLeave";
import { toast } from "react-toastify";

function* checkIsExitsReqLeaveWork(action) {
  const screenCode = action.payload;
  const { longTerm } = yield select(selectFormReqLeave);
  const { employeeCode } = yield select(timeListConfigSelector);
  const id = yield select(selectIdRequestLeaveDetail);

  try {
    if (!longTerm?.fromDate || !longTerm?.toDate) return;
    const newFormData = {
      id: id || undefined,
      fromDate: longTerm?.fromDate?.toISOString(),
      toDate: longTerm?.toDate?.toISOString(),
      employeeCode: employeeCode,
    };
    const res = yield call(checkIsExitsReqLeaveApi, newFormData, screenCode);
    if (res) {
      yield put({
        type: checkIsExitsReqLeaveSuccess.type,
      });
      //   toast.success("Cập nhật đơn thành công!");
    }
  } catch (err: any) {
    yield put({
      type: checkIsExitsReqLeaveFailed.type,
    });
    toast.error(err?.response?.data?.message || "Đã có lỗi xảy ra!");
  }
}

function* watchCreateReqArriveLate() {
  yield takeLatest(checkIsExitsReqLeaveStart.type, checkIsExitsReqLeaveWork);
}

export default function* checkIsExitsReqLeaveSaga() {
  yield all([watchCreateReqArriveLate()]);
}
